import { App } from '@capacitor/app'
import { SplashScreen } from '@capacitor/splash-screen'
import { StatusBar, Style } from '@capacitor/status-bar'

import { isNativePlatform } from './platform'

// One-time native shell setup. No-op on web. Safe to call before React renders.
export function initNativeShell(): void {
    if (!isNativePlatform()) return

    // Dark status bar content to match the app's dark theme.
    StatusBar.setStyle({ style: Style.Dark }).catch(() => { })

    // Hide the launch splash once the web layer is up.
    SplashScreen.hide().catch(() => { })

    // Android hardware back button: navigate history, or exit at the root.
    App.addListener('backButton', ({ canGoBack }) => {
        if (canGoBack) {
            window.history.back()
        } else {
            App.exitApp()
        }
    })
}
